import { useEffect } from "react";

const SITE_NAME = "Raki Solutions Singapore";
const ORIGIN = "https://www.rakisolutions.com";

function setMeta(selector, attr, key, content) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({ title, description, path = "", image = "/og-raki-share-2026.jpg", imageAlt, noindex = false }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : "Raki Solutions | AI sales workflows in Singapore";
    document.title = fullTitle;

    setMeta('meta[name="description"]', "name", "description", description);
    setMeta('meta[property="og:title"]', "property", "og:title", fullTitle);
    setMeta('meta[property="og:description"]', "property", "og:description", description);
    setMeta('meta[property="og:url"]', "property", "og:url", `${ORIGIN}${path}`);
    setMeta('meta[property="og:image"]', "property", "og:image", `${ORIGIN}${image}`);
    setMeta('meta[property="og:image:alt"]', "property", "og:image:alt", imageAlt || fullTitle);
    setMeta('meta[name="twitter:title"]', "name", "twitter:title", fullTitle);
    setMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
    setMeta('meta[name="twitter:image"]', "name", "twitter:image", `${ORIGIN}${image}`);
    setMeta('meta[name="robots"]', "name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setCanonical(`${ORIGIN}${path}`);

    const keywords = document.head.querySelector('meta[name="keywords"]');
    if (keywords) keywords.remove();
  }, [title, description, path, image, imageAlt, noindex]);

  return null;
}
